import actions from './topology.actions';
import mutations from './topology.mutations';
import getters from './topology.getters';
interface Option {
  key: string;
  label: string;
}
export interface Duration {
  start: string;
  end: string;
  step: string;
}
export interface Call {
  latency: number;
  cpm: number;
  isAlert: boolean;
  source: string | any;
  target: string | any;
  id: string;
  detectPoints: string[];
}
interface Node {
  apdex: number;
  avgResponseTime: number;
  cpm: number;
  id: string;
  isAlarm: boolean;
  name: string;
  numOfServer: number;
  numOfServerAlarm: number;
  numOfServiceAlarm: number;
  sla: number;
  type: string;
}

export interface EndpointDependencyConidition {
  serviceName: string;
  endpointName: string;
  destServiceName: string;
  destEndpointName: string;
  duration: Duration;
}

export interface State {
  [x: string]: any;
  callback: any;
  calls: Call[];
  nodes: Node[];
  detectPoints: string[];
  selectedServiceCall: Call | null;
  currentNode: any;
  currentLink: any;
  current: Option;
  mode: boolean;
  getResponseTimeTrend: number[];
  getResponseTimeAverage: number[];
  getSLATrend: number[];
  getThroughputTrend: number[];
  getLoadChildTrend: {
    loadCountTotal: { LoadCountTotal: number[] };
    loadCountPerMin: { LoadCountPM: number[] };
  };
  getErrorTrend: number[];
  getErrorChildTrend: {
    errorPercentage: number[];
    errorCountTotal: { ErrorCountTotal: number[] };
    errorCountPerMin: { ErrorCountPM: number[] };
  };
  responsePercentile: { [key: string]: number[] };
  instanceDependency: {
    calls: Call[];
    nodes: Node[];
  };
  endpointDependency: {
    calls: Call[];
    nodes: Node[];
  };
  selectedInstanceCall: Call | null;
  instanceDependencyMetrics: { [key: string]: any };
  endpointDependencyMetrics: { [key: string]: any };
  currentEndpointDepth: { key: number; label: string };
  queryInstanceMetricsType: string;
  serviceThroughput: { Throughput: number[] };
  serviceSLA: { SLA: number[] };
  serviceResponseTime: { ResponseTime: number[] };
  serviceResponseTimeAvg: { ResponseTimeAvg: number[] };

  servicePercentile: { [key: string]: number[] };
  serviceApdexScore: { ApdexScore: number[] };
  serviceApdexScoreAverage: { ApdexScoreAvg: number[] };
  serviceErrorCount: { ErrorCount: number[] };
  serviceErrorCountChild: {
    errorPercentage: { ErrorCountPer: number[] };
    errorCountTotal: { ErrorCountTotal: number[] };
    errorCountPerMin: { ErrorCountPM: number[] };
  };
  serviceLoadChild: {
    serviceLoadTotal: { load: number[] };
    serviceLoadPerMin: { load: number[] };
  };
  topoEndpoints: any[];
  topoInstances: any[];
}

const initState: State = {
	callback: '',
	mode: true,
	detectPoints: [],
	selectedServiceCall: null,
	calls: [],
	nodes: [],
	currentNode: {},
	currentLink: {},
	current: {
		key: 'default',
		label: 'default'
	},
	getResponseTimeTrend: [],
	getResponseTimeAverage: [],
	getSLATrend: [],
	getThroughputTrend: [],
	getLoadChildTrend: {
		loadCountTotal: { LoadCountTotal: [] },
		loadCountPerMin: { LoadCountPM: [] }
	},
	getErrorTrend: [],
	getErrorChildTrend: {
		errorPercentage: [],
		errorCountTotal: { ErrorCountTotal: [] },
		errorCountPerMin: { ErrorCountPM: [] }
	},
	responsePercentile: {},
	instanceDependency: {
		calls: [],
		nodes: []
	},
	endpointDependency: {
		calls: [],
		nodes: []
	},
	selectedInstanceCall: null,
	instanceDependencyMetrics: {},
	endpointDependencyMetrics: {},
	currentEndpointDepth: { key: 2, label: '2' },
	queryInstanceMetricsType: '',
	serviceThroughput: { Throughput: [] },
	serviceSLA: { SLA: [] },
	serviceResponseTime: { ResponseTime: [] },
	serviceResponseTimeAvg: { ResponseTimeAvg: [] },
	servicePercentile: {
		p50: [],
		p75: [],
		p90: [],
		p95: [],
		p99: []
	},
	serviceApdexScore: { ApdexScore: [] },
	serviceApdexScoreAverage: { ApdexScoreAvg: [] },
	serviceErrorCount: { ErrorCount: [] },
	serviceErrorCountChild: {
		errorPercentage: { ErrorCountPer: [] },
		errorCountTotal: { ErrorCountTotal: [] },
		errorCountPerMin: { ErrorCountPM: [] }
	},
	serviceLoadChild: {
		serviceLoadTotal: { load: [] },
		serviceLoadPerMin: { load: [] }
	},
	topoEndpoints: [],
	topoInstances: [],
	topoOverviewLeftState: false,
	topoOverviewRightState: false,
	topoInfraRightState: false
};

export default {
  namespaced: true,
  state: initState,
  getters: getters,
  actions: actions,
  mutations: mutations
};
